import { ROUTES } from '@/constants/routes';
import type { BlogVariant } from '@/types/blog';

export const BLOG_AGENT_KEY = 'mariana';
export const BLOG_TENANT_ID = import.meta.env.VITE_BLOG_TENANT_ID;

export const BLOG_WORDPRESS_SITE_IDS: Record<BlogVariant, string> = {
  ledger: '254977090',
  inference: '254987303',
};

export const BLOG_VARIANT_QUERY_PARAM = 'track';

export const getBlogVariant = (pathname: string): BlogVariant =>
  pathname.startsWith(ROUTES.BLOG_INFERENCE) ? 'inference' : 'ledger';

export const getBlogVariantFromQuery = (
  value: string | null | undefined
): BlogVariant => (value === 'inference' ? 'inference' : 'ledger');

export const normalizeBlogSlug = (value?: string | null) =>
  (value || '')
    .toLowerCase()
    .replace(/&[a-z0-9#]+;/gi, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getBlogPostIdFromSlug = (slug?: string | null) =>
  slug?.match(/^(\d+)(?:-|$)/)?.[1];

export const getBlogPostHref = (
  postId: number | string,
  variant: BlogVariant,
  slug?: string | null
) => ROUTES.BLOG_DETAILS(String(postId), normalizeBlogSlug(slug), variant);
